import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";

export const fectchReservation = () => async (dispatch) => {
  try {
    const response = await instance.get("reservations");
    console.log("REPONSERESERVATION", response);
    const dataFilterByFlagTrue = response.data.data.filter(
      (item) => item.flag === 1
    );
    console.log("dataFilterByFlagTrue", dataFilterByFlagTrue);
    dispatch(fetchReservationFulfilled(dataFilterByFlagTrue.length));
  } catch (error) {
    console.log();
  }
};
export const removeFlagReservation = (payload) => async (dispatch) => {
  try {
    const response = await instance.post("/updateFlagReservation/" + payload);
    console.log("REPONSERECLAMATION", response);
    if (response.status === true) {
      dispatch(removeItem());
    }
  } catch (error) {
    console.log();
  }
};
export const reservationReducer = createSlice({
  name: "Reservation",
  initialState: { reservation_length: null },
  reducers: {
    removeItem: (state) => {
      const nouveau_length = state.reservation_length - 1;
      return { ...state, reservation_length: nouveau_length };
    },
    fetchReservationFulfilled: (state, action) => {
      state.status = true;
      state.reservation_length = action.payload; // Met à jour state.Reservation_length avec les données de l'API
    },
  },
});

export const { handleTotalNew, fetchReservationFulfilled, removeItem } =
  reservationReducer.actions;
export default reservationReducer.reducer;
